export type Status = 'ACTIVE' | 'INACTIVE' | 'UNKNOWN';

interface HasStatus {
  status?: string;
}

export const isStatusActive = (item: HasStatus): boolean => {
  return item.status === 'ACTIVE';
};
